import { ScrollArea } from "@base-ui/react/scroll-area"
import React, { useMemo } from "react"

import { GlobalSearchResultType } from "features/global-search/types/GlobalSearch"

import { useGlobalSearchContext } from "../../GlobalSearchContext"
import { GlobalSearchListbox } from "../GlobalSearchListbox"
import { ProductGlobalSearchListItem } from "../list-items/ProductGlobalSearchListItem"

export const GlobalSearchProductTab = React.memo(() => {
  const { options, activeTab } = useGlobalSearchContext()
  const isTabActive = activeTab === GlobalSearchResultType.PRODUCT

  const items = useMemo(
    () => options[GlobalSearchResultType.PRODUCT]?.options ?? [],
    [options]
  )

  return (
    <div className="global-search__tab-content global-search__product-tab">
      <ScrollArea.Root className="scroll-area scroll-area--vertical shadow-s global-search__scroll-area">
        <ScrollArea.Viewport className="scroll-area__viewport">
          <ScrollArea.Content className="scroll-area__content">
            <GlobalSearchListbox>
              {items.map((item, index) => (
                <ProductGlobalSearchListItem
                  key={item.key ?? item.value}
                  option={item}
                  index={index}
                  isTabActive={isTabActive}
                />
              ))}
            </GlobalSearchListbox>
          </ScrollArea.Content>
        </ScrollArea.Viewport>
        <ScrollArea.Scrollbar
          orientation="vertical"
          className="scroll-area__scrollbar"
        >
          <ScrollArea.Thumb className="scroll-area__thumb" />
        </ScrollArea.Scrollbar>
      </ScrollArea.Root>
    </div>
  )
})
